import React from "react";
// Import icons
import wifiIcon from "../assets/svg/wifi.svg";
import chipIcon from "../assets/svg/chip.svg";
import screenIcon from "../assets/svg/screen.svg";
import android from "../assets/svg/android.svg";
// Import hardware product images
import c20Pro from "../assets/images/Landi C20 Pro Dual Premier.png";
import c20ProSE from "../assets/images/Landi C20 Pro SE Dual Premier.png";
import c20ProSESingle from "../assets/images/Landi C20 Pro SE Single.png";
import c20DS from "../assets/images/Landi C20 DS.png";
import m20SE from "../assets/images/Landi M20 SE.png";
import m20 from "../assets/images/Landi M20.png";

function CompatibleDevices() {
  const hardwareModels = [
    {
      name: "Landi C20 Pro Dual Premier",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 64GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '15.6" 1920 x 1080', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: c20Pro,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi C20 Pro SE Dual Premier",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 64GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '15.6" 1920 x 1080', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: c20ProSE,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi C20 Pro SE Single",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 64GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '15.6" 1920 x 1080', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: c20ProSESingle,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi C20 DS",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "4GB + 32GB", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '15.6" 1920 x 1080', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: c20DS,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi M20",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "3GB + 32GB Flash", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '5.5" 720 x 1280', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: m20,
      bgColor: "bg-gray-50",
    },
    {
      name: "Landi M20 SE",
      specs: [
        { icon: <img src={wifiIcon} alt="wifi" className="w-6 h-6" />, text: "WiFi", subtitle: "Network Transmission" },
        { icon: <img src={chipIcon} alt="chip" className="w-6 h-6" />, text: "3GB + 32GB Flash", subtitle: "Memory and Storage" },
        { icon: <img src={screenIcon} alt="screen" className="w-6 h-6" />, text: '5.5" 720 x 1280', subtitle: "Main Display" },
        { icon: <img src={android} alt="android" className="w-6 h-6" />, text: "Android 13", subtitle: "Operating System" },
      ],
      image: m20SE,
      bgColor: "bg-gray-50",
    },
  ];

  return (
    <section className="py-12 px-4 md:py-16 bg-white md:-mb-1" id="home">
      <div className="container mx-auto max-w-6xl">
        <h1 className="text-4xl md:text-6xl font-bold my-6">Compatible Devices</h1>
        <p className="text-gray-700 font-roboto mb-8 text-[23px]">
          VernPOS is compatible with a wide range of POS terminals, card readers, and mobile devices for seamless payment acceptance.
        </p>
      </div>
      <div className="overflow-x-auto max-w-6xl mx-auto">
        <div className="flex flex-nowrap gap-7 p-10 min-w-max">
          {hardwareModels.map((model, index) => (
            <div className="flex flex-shrink-0 rounded-[28px] border hover:-translate-y-4 transition-transform duration-300" key={index}>
              <div className="p-6">
                <h4 className="flex font-bold text-vern w-60 text-2xl mb-2">{model.name}</h4>
                <ul className="space-y-2">
                  {model.specs.map((spec, i) => (
                    <li key={i} className="flex items-center">
                      {spec.icon}
                      <div className="ml-2">
                        <div className="font-medium">{spec.text}</div>
                        <div className="text-xs text-gray-500">{spec.subtitle}</div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex items-center pr-6">
                <img className="w-auto h-[200px]" src={model.image} alt={model.name} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CompatibleDevices;
